(() => {
  if (window.__sharkiSizingInit) return;
  window.__sharkiSizingInit = true;
  const adult = ['S','M','L','XL','2XL','3XL','4XL'];
  const widths=[53,55,57,59,63,67,71], lengths=[71,74,77,80,84,88,92];
  const women=['S','M','L','XL','2XL'];
  const womenWidths=[44,46,48,49.5,51],womenLengths=[65,67,69,70,71];
  const womenHeights=['150–160','160–165','165–170','170–175','175–178'];
  const womenWeights=['45–55','50–60','60–70','65–75','75–85'];
  const children=['2-3 ans','4-5 ans','6-7 ans','8-9 ans','10-11 ans','12-13 ans'];
  const lower=[92,105,117,129,141,153], upper=[104,116,128,140,152,164];
  const normalize=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  function getCategory(root){
    let profile={};try{profile=JSON.parse(root.querySelector('[data-sf-size-profile]')?.textContent||'{}')}catch{}
    const explicit=normalize(profile.category_override);
    if(['homme','femme','enfant','survetement'].includes(explicit))return explicit;
    const val=normalize([profile.title,profile.type,...(profile.tags||[])].join(' '));
    if(/survetement|tracksuit|track suit|jogging/.test(val))return 'survetement';
    if(/femme|women|woman|lady|ladies|girl(?!s?\s?\d)/.test(val))return 'femme';
    if(/enfant|junior|kids?|bebe|2-3 ans|4-5 ans|6-7 ans|8-9 ans|10-11 ans|12-13 ans/.test(val))return 'enfant';
    return 'homme';
  }
  function recommendAdult(h,w){
    // Seuils SharkiFC : poids d'abord, puis ajustement unique selon la hauteur.
    // Les bornes de poids ont ete deduites de tests, pas du code source tiers.
    let idx = w < 62 ? 0 : w < 73 ? 1 : w < 84 ? 2 : w < 98 ? 3 : w < 109 ? 4 : w < 125 ? 5 : 6;
    if (h < 168) idx -= 1;
    else if (h >= 188) idx += 1;
    return Math.max(0,Math.min(6,idx));
  }
  function recommendWoman(h,w){
    // Grille fournisseur SharkiFC. La hauteur est prioritaire ; le poids
    // départage les tailles voisines lorsque les plages fournisseur se recouvrent.
    const heightIdx=h<=160?0:h<=165?1:h<=170?2:h<=175?3:4;
    const ranges=[[45,55],[50,60],[60,70],[65,75],[75,85]];
    const valid=ranges.map((r,i)=>w>=r[0]&&w<=r[1]?i:-1).filter(i=>i>=0);
    if(valid.length)return valid.reduce((best,i)=>Math.abs(i-heightIdx)<Math.abs(best-heightIdx)?i:best,valid[0]);
    // Hors des tranches de poids publiées : privilégier la hauteur.
    return heightIdx;
  }
  function buildTable(category,active){
    let cols,rows;
    if(category==='enfant'){cols=children;rows=[['Hauteur (cm)',...children.map((_,i)=>lower[i]+'–'+upper[i])]]}
    else if(category==='femme'){cols=women;rows=[['Longueur (cm)',...womenLengths],['Largeur (cm)',...womenWidths],['Hauteur (cm)',...womenHeights],['Poids (kg)',...womenWeights]]}
    else {cols=adult;rows=[['Largeur (cm)',...widths],['Longueur (cm)',...lengths]]}
    const head='<tr><th scope="col">Taille</th>'+cols.map((c,i)=>`<th scope="col" class="${i===active?'sfsg-active':''}">${c}</th>`).join('')+'</tr>';
    return '<table><thead>'+head+'</thead><tbody>'+rows.map(row=>'<tr><th scope="row">'+row[0]+'</th>'+row.slice(1).map((c,i)=>`<td class="${i===active?'sfsg-active':''}">${c}</td>`).join('')+'</tr>').join('')+'</tbody></table>';
  }
  function init(root){
    if(root.dataset.sfsgReady)return;root.dataset.sfsgReady='1';
    const node=root.querySelector('[data-sfsg]');if(!node)return;
    const dialog=node.querySelector('dialog'),btn=node.querySelector('[data-sfsg-submit]'),result=node.querySelector('[data-sfsg-result]');
    const height=node.querySelector('[data-sfsg-height]'),secondary=node.querySelector('[data-sfsg-secondary]');
    const choose=node.querySelector('[data-sfsg-choose]'),chooseError=node.querySelector('[data-sfsg-choose-error]');
    let recommendedSize=null;
    const table=node.querySelector('[data-sfsg-table]'),note=node.querySelector('[data-sfsg-note]');
    const category=getCategory(root);
    const child=category==='enfant', woman=category==='femme', track=category==='survetement';
    const open=()=>{
      recommendedSize=null;choose.hidden=true;chooseError.hidden=true;
      result.hidden=true;result.textContent='';table.innerHTML=buildTable(category,-1);
      node.querySelector('[data-sfsg-title]').textContent=child?'Trouve sa taille':woman?'La bonne taille, la bonne coupe':track?'Trouve ta taille de survêtement':'Trouve ta taille';
      node.querySelector('[data-sfsg-intro]').textContent=child?'Indique sa taille en cm. Tu peux aussi renseigner son âge.':woman?'Une coupe pensée pour elles : retrouve ici les mesures des maillots femme.':track?'Donne ta taille et ton poids : on t’aide à choisir ton survêtement.':'Indique ta taille et ton poids, on te dit quoi prendre.';
      height.placeholder=child?'122':woman?'165':'180';height.value='';secondary.value='';
      node.querySelector('[data-sfsg-secondary-label]').firstChild.textContent=child?'SON ÂGE (ANS)':'TON POIDS (KG)';
      secondary.placeholder=child?'7':woman?'60':'78';
      note.textContent=child?'Ton kit comprend le maillot et le short.':woman?'Mesures prises à plat, maillot posé. La coupe femme est plus ajustée : vérifie bien le tableau avant de commander.':track?'Mesures prises à plat, maillot posé. Largeur = d’une aisselle à l’autre. Pour les survêtements, cette grille concerne le haut.':'Mesures prises à plat, maillot posé. Largeur = d’une aisselle à l’autre. Version Match : coupe plus ajustée. Nous te conseillons de prendre une taille au-dessus de ta taille habituelle pour un meilleur confort.';
      node.querySelector('.sfsg-inputs').hidden=false;btn.hidden=false;
      dialog.showModal();
    };
    dialog.querySelector('[data-sfsg-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
    btn.addEventListener('click',()=>{
      const h=Number(height.value),v=Number(secondary.value);
      if(child ? (!Number.isFinite(h)||h<0||h>230||(!h&&(!v||v<2||v>13))) : woman ? (h<145||h>190||v<35||v>120) : (h<130||h>230||v<30||v>250)){
        result.textContent=child?'Indique sa taille ou un âge entre 2 et 13 ans.':'Vérifie ta taille et ton poids pour continuer.';result.hidden=false;return;
      }
      let idx=child ? (h ? upper.findIndex(x=>h<=x) : Math.min(5,Math.floor((v-2)/2))) : woman ? recommendWoman(h,v) : recommendAdult(h,v);
      idx=Math.max(0,idx<0?(child?5:0):idx);
      const recommended=child?children[idx]:woman?women[idx]:adult[idx];
      recommendedSize=recommended;choose.hidden=false;chooseError.hidden=true;
      result.replaceChildren();
      const strong=document.createElement('strong');strong.textContent=recommended;result.append(strong);
      const msg=document.createElement('span');
      msg.textContent=child?"Les kits enfants sont taillés à l'âge. S'il est grand pour son âge, prends au-dessus.":woman?'Une taille conseillée pour la coupe femme. Vérifie les mesures juste en dessous.':track?'Pour être bien dans ton survêtement, voici la taille qu’on te conseille.':h>=188?'Tu es grand : on monte d’une taille pour la longueur.':h<168?'Tu es plutôt petit : cette taille tombera mieux.':'Nos maillots taillent juste, prends ta taille habituelle.';
      result.append(msg);result.hidden=false;
      table.innerHTML=buildTable(category,idx);

    });
    // Choisir la variante du produit : événements natifs Shopify/Easify conservés.
    function canonicalSize(value){
      return normalize(value).toUpperCase().replace(/\s+/g,'').replace(/^XXL$/,'2XL').replace(/^(\d+)[–—-](\d+)ANS?$/,'$1-$2ANS');
    }
    choose.addEventListener('click',()=>{
      if(!recommendedSize)return;
      const group=root.querySelector('[data-sf-size]');
      const wanted=canonicalSize(recommendedSize);
      if(!group){chooseError.textContent='Sélecteur de taille introuvable sur cette fiche.';chooseError.hidden=false;return;}
      const radios=Array.from(group.querySelectorAll('input[type="radio"]'));
      const radio=radios.find(el=>canonicalSize(el.value)===wanted);
      const select=group.querySelector('select');
      const option=select&&Array.from(select.options).find(el=>!el.disabled&&canonicalSize(el.value||el.textContent)===wanted);
      if(radio){
        if(radio.disabled){chooseError.textContent='Cette taille est indisponible pour le moment.';chooseError.hidden=false;return;}
        radio.checked=true;
        radio.dispatchEvent(new Event('input',{bubbles:true}));
        radio.dispatchEvent(new Event('change',{bubbles:true}));
      }else if(option){
        select.value=option.value;
        select.dispatchEvent(new Event('input',{bubbles:true}));
        select.dispatchEvent(new Event('change',{bubbles:true}));
      }else{
        chooseError.textContent='Cette taille n’est pas proposée pour ce produit. Choisis une taille dans la fiche.';
        chooseError.hidden=false;return;
      }
      dialog.close();
    });
    root.addEventListener('click',e=>{
      const trigger=e.target.closest('[data-sfsg-trigger]');
      if(trigger){e.preventDefault();open();}
    });
  }
  const scan=()=>document.querySelectorAll('product-info.sf-product-page').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
})();
